export const IndustriesPageText = {
  _1: 'Industries & Cases',
  _2: 'Air quality is a hot topic, relevant to many domains. aircheckr turns air quality information into something positive. By integrating aircheckr into specific applications, you empower your customers to directly or indirectly make better decisions and take actions in order to breathe better air.'
};


export const IndustriesText = {
  homeandoffice: {
    title: 'Home & Office',
    quote: 'Indoor air pollution has considerable impact on health and is greatly affected by outdoor air pollution.',
    author: 'Royal College of Physicians, 2016'
  },
  auto: {
    title: 'Automotive',
    quote: 'Levels of some pollutants and toxic compounds can be as much as 10 times higher inside vehicles than alongside the road.',
    author: 'Berkley Wellness, 2016 '
  },
  health: {
    title: 'Digital Health',
    quote: '6.5 million people in the EU fall sick, as air pollution causes diseases such as strokes, asthma and bronchitis.',
    author: 'European Environment Agency, 2014'
  },
  info: {
    title: 'Informative',
    quote: '“Keeping digital signage or web content fresh is important.” Air quality info is ideal as it changes regularly over time and space.',
    author: 'Dynamax'
  },
  outdoor: {
    title: 'Outdoor',
    quote: 'When we exercise, the volume of air pumped by the lungs can be eight times higher than the amount pumped during rest.',
    author: 'The European Lung Foundation'
  },
  intelli: {
    title: 'Intelligence',
    quote: 'The number of premature deaths due to the consequences of air pollution in the EU is more than ten times the toll of traffic accidents.',
    author: 'European Environment Agency, 2014'
  }
};

export default IndustriesPageText;



// WEBPACK FOOTER //
// ./src/input-text/en/industries_page.js